import React, { useEffect, useRef } from "react";
import { useState } from "react";
import styled from "styled-components";
import { useParams } from "react-router";
import { NFT_LIST, NFT_BUYERS } from "../constants/urls";
import NFTNav from "../components/NavComponents/NFTNav";
import Card from "../components/desktop/Card";
import EarlyAccessFooter from "../components/desktop/EarlyAccessFooter";
import ModalBidComponent from "../components/BidComponents/PlaceBidModalComponent";
import ModalMetamaskInstallComponent from "../components/MetamaskInstallComponent/ModalMetamaskInstallComponent";
import {
    useHistory,
  } from "react-router-dom/cjs/react-router-dom.min";
import eventBus from '../utils/globalPubSub';

import { PaymentContext } from '../utils/paymentConfigProvider';


const CoinGecko = require('coingecko-api');
const CoinGeckoClient = new CoinGecko();


const url = window.location;
let domain = (new URL(url));
domain = domain.origin;


const Mobile = styled.div`
  display: none;
  background: #000;
  @media only screen and (max-device-width: 480px) {
  display: flex;
  flex-direction: column;
  }
`;

const CollectorsTitle = styled.div`
  margin-top: 65px;
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: bold;
  font-size: 28px;
  line-height: 90.1%;
  /* identical to box height, or 38px */

  display: flex;
  align-items: center;

  color: ${props => props.active ? '#FFFFFF': 'rgba(255,255,255,0.45)'};
  margin: 4px;

  text-shadow: 0px 4px 20px rgba(0, 0, 0, 0.4);
  text-align: center;
  margin-top: 36px;
`;

const Desktop = styled.div`
  display: none;
  background: #000;
  @media (min-device-width: 481px) {
  display: flex;
  flex-direction: column;
  /* height: 100vh; */
  height: 100%;
  /* overflow: hidden; */
  }
`;

const Container = styled.div`
  padding: 12px 120px;
  display: flex;
  flex-direction: column;
  /* overflow: scroll; */
  /* height: 100vh; */
`;


const CollectorAddress = styled.div`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: bold;
  font-size: 32px;
  line-height: 90.1%;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  text-shadow: 0px 4px 20px rgba(0, 0, 0, 0.4);
  margin-bottom: 10px;
`;

const CollectorBoughtTime = styled.div`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.4;
`;

const Perks = styled.div`
  font-family: 'Space Mono';
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 90.1%;
  color: #FFFFFF;
`;


const CollectorItemBought = styled.a`
  font-family: 'IBM Plex Mono', monospace;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: #FFFFFF;
  opacity: 0.4;
`;


const BlankHeader = styled.div`
    font-family: 'IBM Plex Mono', monospace;
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 110%;
    /* or 40px */

    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    margin-top: 85px;

`;

const DesktopList = styled.div`
@media only screen and (max-device-width: 480px) {
    margin: 0px!important;
  }
`;

const CtaButton = ({ count, img }) => {
    return (
	<a
	    onClick={() => {
		setOpen(true);
		console.log(open);
		window.analytics.track('modal_open_cta_clicked', {
		    icon: `${img}`,
		})
		
	    }}
	    style={{ textAlign: "center" }}
	>
	    <img src={img} />
	    <div style={{ textAlign: "center", marginBottom: 16 }}>{count}</div>
	</a>
    );
};


function useForceUpdate(){
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update the state to force render
}

export default function NFTListPage(props) {
    
    const [glip, setGlip] = useState({});
    const [data, dataSet] = useState();
    const [videos, videosSet] = useState([]);
    const [activeTab, setActiveTab] = useState('NFT');
    const [config, setConfig] = useState({});
    const [perkBanners, setPerkBanners] = useState([]);
    const [collectors, setCollectors] = useState([]);
    const [bids, setBids] = useState([]);
    const [perks, setPerks] = useState([]);
    const history = useHistory();
    
    const [isOpen, setIsOpen] = useState(false);
    const [startWithWithdraw, setStartWithWithdraw] = useState(false);
    const [startWithDeposit, setStartWithDeposit] = useState(false);
    const [onlySwitchChain, setOnlySwitchChain] = useState(false);
    const [maticPrice, setMaticPrice] = useState(0);
    
    const paymentConfig = useRef({});
    
    const setPaymentConfig = (newVal)=>{
        console.log('paymentConfig.current', newVal);
        paymentConfig.current = newVal;
        forceUpdate();
    }
    
    const [
        metaMaskInstallComponentIsOpen,
        setMetaMaskInstallComponentIsOpen
    ] = useState(false);
    
    const forceUpdate = useForceUpdate();
    const { username } = useParams();
    
    async function fetchMyAPI(page, size) {
        let test = new URLSearchParams(props.location.search).get("test")
        let fetchUrl = NFT_LIST + username;
        if(domain.includes('test.glip.gg') || domain.includes(
            'localhostgg' )){
            fetchUrl += '&test=1'
        }
        // let response = await fetch(fetchUrl);
        let response = await fetch(fetchUrl + `&page=${page}&size=${size}`);
        console.log(fetchUrl + `&page=${page}&size=${size}`)
        response = await response.json();
        
        if(response.data) {
            const videos = [];
            for(var i = 0; i < response.data.videos.length; i++) {
                if(i == 0) {
                    setGlip(response.data.videos[i]);
                    console.log(response.data.videos[i])
                } else {
                    videos.push(response.data.videos[i])
                    videosSet(videos);
                }
            }
            setBids(response.data.firstVideoBids);
            setPerks(response.data.perks);
            dataSet(response.data);
            setPaymentConfig(response.data.config);
            forceUpdate();
        }else {
	    dataSet(true)
        }
    }
    
    useEffect(() => {
        eventBus.on("new-bid-add", (publicAddress) => {
            console.log('new-bid-add');
            fetchMyAPI();
        });
	    fetchMyAPI(0, 50);
        return ()=>{
            eventBus.remove("new-bid-add");
        };
    }, []);
    

    useEffect(() => {
        async function fetchMyAPI() {
            // TODO Change endpoint
            let response = await fetch(NFT_BUYERS + username);
            response = await response.json();
            console.log('response=============>',response);
            
            if(response.data) {
                const videos = [];
                for(var i = 0; i < response.data.videos.length; i++) {  
                    videos.push(response.data.videos[i])        
                }
                setCollectors(videos);
            }
        }
	    fetchMyAPI();
    }, []);
    
    
    // useEffect(() => {
    //     CoinGeckoClient.coins.fetch('matic-network', {}).then(data => {
    //         setMaticPrice(data.data.market_data.current_price.usd);
    //         console.log(data.data)
    //     });
    // }, []);        

    
    if (!data) {
	    return <>
            <Desktop>
                <NFTNav
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    creator={username}
                    userChainId={1}
                    showTabs={false}
                />
            </Desktop>
        </>;
    }
    
    const desktop_list = videos.map((item, index) => {
        return (
            <Card key={`card-desktop-${index}`} maticPrice={maticPrice} topcard={false} index={index} item={item} />
        );
    });
    
    const perk_list = perkBanners.map((item, index) => {
        return (
            <img  key={`perk-image-${index}`}  src={item.url} style={{margin: 10, height: 458}}/>
        );
    });
    
    const collectors_list = collectors.map((item, index) => {
	var t = Math.floor((new Date().getTime()/1000 - new Date(item.mintedAt).getTime()/1000)/3600);
    //TODO change address to twitch username
    let buyer = '';
    if(item.owner.startsWith('0x'))
        buyer = `0x...${item.owner.substr(item.owner.length - 4)}`;
    else
        buyer = item.owner;
	return (
	    <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            width: '100%',
            paddingTop: 32,
            paddingBottom: 26,
            borderBottom: '1px solid rgba(255,255,255,0.15)',
	    }}  key={`collectors-${index}`}>
		<div style={{display: 'flex', flexDirection: 'column',}}>
		    <CollectorAddress className="hover" onClick={() => history.push(`/address/${buyer}`)}>{buyer}</CollectorAddress>
		    <CollectorBoughtTime>{t}h ago</CollectorBoughtTime>
		</div>
		<CollectorItemBought onClick={() => history.push(`/u/${username}/${item.serial}`)} >bought #{item.serial}</CollectorItemBought>
	    </div>
	);
    });
    
    const perksList = perks.map((item, index) => {
	//TODO add classname for different types
	return (
	    <Perks
            key={`perks-${index}`}
            className={`perk-tile perk-${item.id}`}
            style={{
                borderRadius: 100,
                margin: 6,
                padding: '12px 16px',
            }}>
		{item.name}
	    </Perks>
	);
    });
    
    
    return (
	<PaymentContext.Provider value={paymentConfig.current}>
            <Mobile>
                <NFTNav
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    creator={username}
                    handleWithdrawClicked={()=>{handleWithdrawClicked()}}
                    handleDepositClicked={()=>{handleDepositClicked()}}
                    userChainId={data.creatorChainId}
                    showTabs={true}
                    expanded={false}
                />

                <Card maticPrice={maticPrice} topcard={true} index={1} item={glip}
		      username={username} perks={perks} bids={bids}
		      setMetaM-askInstallComponentIsOpen={(val)=>setMetaMaskInstallComponentIsOpen(val) }
		      placeBidClicked={()=>{
			  setStartWithWithdraw(false);
			  setStartWithDeposit(false);
			  setIsOpen(true)}}
		/>
		{/* item list below, for smalelr cards*/}
                <div style={{display: 'flex', marginLeft: 20}}>
                    <CollectorsTitle className="hover" active={activeTab == 'NFT'} onClick={() => setActiveTab('NFT')}>MORE NFTs</CollectorsTitle>
                    <CollectorsTitle style={{marginLeft: 12}} className="hover" active={activeTab == 'collector'} onClick={() => setActiveTab('collector')}>COLLECTORS</CollectorsTitle>

                </div>
                {activeTab == 'NFT' ? <DesktopList
                                          className={"desktop-item-list"}
                                          style={{
                                              display: "flex",
                                              flex: 2,
                                              flexDirection: "row",
                                              // overflow: "scroll",
                                              marginTop: 44,
                                              flexWrap: 'wrap',
                                              marginLeft: -10,
                                              marginRight: -10,
                                              justifyContent: 'center',
                                              width: '100%',
                                          }}
                                      >
                    {desktop_list}
                </DesktopList> 
                : <div style={{padding: 24}}>
                    {collectors_list}
                </div>
                }       
		

            </Mobile>   
	    <Desktop>
		<NFTNav
		    activeTab={activeTab}
		    setActiveTab={setActiveTab}
		    creator={username}
		    handleWithdrawClicked={()=>{handleWithdrawClicked()}}
		    handleDepositClicked={()=>{handleDepositClicked()}}
	            userChainId={data.creatorChainId}
                    showTabs={true}
                    expanded={false}
		/>
		{glip.serial ? <Container>
		    {/* NFT tab */}
		    {/* <div style={{display: activeTab == 'NFT' ? 'block' : 'none'}}> */}
		    <div style={{display: 'block'}}>
			<Card maticPrice={maticPrice} topcard={true}
                              index={1} item={glip}
			      username={username} perks={perks} bids={bids}
			      setMetaM-askInstallComponentIsOpen={(val)=>setMetaMaskInstallComponentIsOpen(val) }
			      placeBidClicked={()=>{
				  setStartWithWithdraw(false);
				  setStartWithDeposit(false);
				  setIsOpen(true)}}
			/>
			{/* item list below, for smalelr cards*/}
                        <div style={{display: 'flex'}}>
                            <CollectorsTitle className="hover" active={activeTab == 'NFT'} onClick={() => setActiveTab('NFT')}>MORE NFTs</CollectorsTitle>
                            <CollectorsTitle style={{marginLeft: 12}} className="hover" active={activeTab == 'collector'} onClick={() => setActiveTab('collector')}>COLLECTORS</CollectorsTitle>

                        </div>
			{activeTab == 'NFT' ? <div
                                                  className={"desktop-item-list"}
                                                  style={{
                                                      display: "flex",
                                                      flex: 2,
                                                      flexDirection: "row",
                                                      // overflow: "scroll",
                                                      marginTop: 44,
                                                      flexWrap: 'wrap',
                                                      marginLeft: -10,
                                                      marginRight: -10
                                                  }}
                                              >
                            {desktop_list}
                        </div>
                        : <>
                            {collectors_list}
                        </>}       
		    </div>


		    {/* Perks tab */}
		    <div style={{display: activeTab == 'collection' ? 'block' : 'none'}}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-evenly',
                            width: '100%',
                            flexWrap: 'wrap',
                        }}>
                            {perk_list}
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%'
                            }}>
                                <CollectorsTitle>LATEST COLLECTORS</CollectorsTitle>
                                {collectors_list}
                            </div>
                        </div>
		    </div>

                    {/* Perks tab */}
		    <div style={{display: activeTab == 'help' ? 'block' : 'none'}}>
                        <div style={{
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-evenly',
                            width: '100%',
                            flexWrap: 'wrap',
                        }}>
                            {perk_list}
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                                alignItems: 'center',
                                width: '100%'
                            }}>
                                <CollectorsTitle>LATEST COLLECTORS</CollectorsTitle>
                                {collectors_list}
                            </div>
                        </div>
		    </div>
		    
		</Container>
                : 
                 <>
                     <BlankHeader>{username}<br></br>
                         is preparing<br></br>
                         the first POWER drop</BlankHeader>
                     <EarlyAccessFooter />
                 </>

		}

	    </Desktop>
	</PaymentContext.Provider>
    );
}

